// `window.RenoEstimatorConfig`'s type is declared once, in
// engine/estimatorClient.ts (RenoEstimatorConfig), and reused here.

/**
 * Renders a real link only when a real privacy policy URL has actually
 * been configured (via `window.RenoEstimatorConfig.privacyPolicyUrl` -
 * the same host-config global the WordPress embed already uses for the
 * pricing REST URL and the GA4 measurement id, see estimatorClient.ts /
 * analyticsClient.ts). Deliberately never falls back to a guessed path
 * like "/privacy-policy" - a link that 404s, or worse, a page that
 * doesn't actually describe what this estimator collects, would be
 * worse than being honest that one isn't set up yet. See
 * docs/privacy-security.md: this component cannot make the privacy
 * policy exist, only link to one an administrator has actually written
 * and configured.
 */
export function PrivacyPolicyLink({ children = "privacy policy" }: { children?: React.ReactNode }) {
  const url = typeof window !== "undefined" ? window.RenoEstimatorConfig?.privacyPolicyUrl : undefined;

  if (!url) {
    return <span className="privacy-policy-link privacy-policy-link--unset">{children} (not yet published)</span>;
  }

  return (
    <a className="privacy-policy-link" href={url} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
}
